/**
 *
 * @description Conditional Wrapper is a wrapper component that conditionally wraps children with a wrapper component.
 * @example
 * ```tsx
 * // `x` is in scope
 *
 * <ConditionalWrapper
 *   condition={x > 10}
 *   renderWithWrapper={(children) => (
 *     <div>{children}</div>
 *   )}
 * >
 *   // children here
 * </ConditionalWrapper>
 *
 * ```
 * (if `x` happens to be more than 10, then the children of `ConditionalWrapper` will rendered wrapped in an additional div. Else the children will render without the additional div wrapper)
 */
const ConditionalWrapper = (props) => {
    const { condition, renderWithWrapper, children } = props;
    return condition ? renderWithWrapper(children) : children;
};

export { ConditionalWrapper };
